/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/fail': {
    width: 98,
    height: 94,
    viewBox: '0 0 98 94',
    data: '<g filter="url(#filter0_d)" fill-rule="evenodd" clip-rule="evenodd" _fill="red"><path pid="0" d="M81.55 86L4.177 11.316 15.613.086 92.987 74.77 81.55 86z"/><path pid="1" d="M93.825 10.316L16.45 85l-9.825-9.648L83.999.668l9.826 9.648z"/></g><defs><filter id="filter0_d" x=".176" y=".085" width="97.649" height="93.915" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs>'
  }
})
